import { useHelpCenter, HELP_CENTER_KEYS } from '@packlink/provider';
import { CustomsDeclaration } from './components/CustomsForm/CustomsDeclaration.js';
import { CustomsFormContext } from './CustomsFormData.js';
import { Divider } from '@shipengine/giger';
import { getCustomsFormDeclarationStyles, getCustomsFormTaxFormStyles, getCustomsFormDividerStyles } from './CustomsFormStyles.js';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';
import { MetricsProvider } from './components/MetricsProvider/MetricsProvider.js';
import { SenderInformationForm } from './components/CustomsForm/TaxForm/SenderInformationForm.js';
import { ReceiverInformationForm } from './components/CustomsForm/TaxForm/ReceiverInformationForm.js';
import { Inventory } from './components/CustomsForm/Inventory/Inventory.js';
import { LegalForm } from './components/CustomsForm/LegalForm.js';

function CustomsForm(_ref) {
  let {
    locale,
    desktopInventoryColSpan,
    tariffNumberLink,
    fieldNamePrefix,
    validTariffNumbers,
    shipmentWeight,
    contentValue,
    defaultCustomsCategory,
    tracker,
    showWindsorWarning = false,
    ...rest
  } = _ref;
  const getHelpCenter = useHelpCenter();
  const regulationLink = getHelpCenter(HELP_CENTER_KEYS.customsRegulations);
  const desktopColumns = desktopInventoryColSpan !== null && desktopInventoryColSpan !== void 0 ? desktopInventoryColSpan : 6;
  return jsx(MetricsProvider, {
    tracker: tracker,
    children: jsx(CustomsFormContext.Provider, {
      value: {
        fieldNamePrefix,
        locale,
        validTariffNumbers,
        tariffNumberLink,
        defaultCustomsCategory
      },
      children: jsxs("section", {
        ...rest,
        children: [jsx(CustomsDeclaration, {
          css: getCustomsFormDeclarationStyles,
          showWindsorWarning: showWindsorWarning
        }), jsxs("section", {
          css: getCustomsFormTaxFormStyles,
          children: [jsx(SenderInformationForm, {}), jsx(ReceiverInformationForm, {})]
        }), jsx(Inventory, {
          colSpanDesktop: desktopColumns,
          shipmentWeight: shipmentWeight,
          contentValue: contentValue
        }), jsx(Divider, {
          css: getCustomsFormDividerStyles
        }), jsx(LegalForm, {
          supportLink: regulationLink
        })]
      })
    })
  });
}

export { CustomsForm };
//# sourceMappingURL=CustomsForm.js.map
